(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cb-fabtech-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cb-fabtech-form')) {
    customElements.define('cb-fabtech-form', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.fields = this.querySelector('fieldset');
        this.button = this.querySelector('button[type="submit"]');
        this.label = this.querySelector('[data-submit-label]');
        this.submitLabel = this.label.textContent;
        this.status = this.querySelector('.cft-form__status');
        this.messages = JSON.parse(this.querySelector('[data-form-messages]').textContent);
        this.startedAt = Date.now();
        this.submissionId = crypto.randomUUID();
        this.endpoint = this.getEndpoint();
        this.form.addEventListener('submit', (event) => this.submit(event));
        this.form.addEventListener('input', (event) => {
          event.target.removeAttribute('aria-invalid');
          this.invalidTracked = false;
          if (!this.started) {
            this.started = true;
            this.track('fabtech_form_start');
          }
        });
        this.form.addEventListener('invalid', (event) => {
          event.target.setAttribute('aria-invalid', 'true');
          if (!this.invalidTracked) {
            this.invalidTracked = true;
            this.track('fabtech_form_validation_error', { error_type: 'invalid_fields' });
          }
        }, true);
        this.button.disabled = !this.endpoint || this.dataset.designMode === 'true';
        this.querySelector('.cft-form__unavailable').hidden = Boolean(this.endpoint);
        this.dataset.state = this.endpoint ? 'ready' : 'unavailable';
        this.bindPageEvents();
      }

      getEndpoint() {
        const configured = this.dataset.webhook.trim();
        if (!configured) return null;
        try {
          const endpoint = new URL(configured, window.location.origin);
          if (endpoint.username || endpoint.password || endpoint.hash) return null;
          const isLoopback = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);
          const isLocalPreview = isLoopback && endpoint.origin === window.location.origin;
          if (endpoint.protocol === 'https:' && /^https:\/\//i.test(configured)) return endpoint.href;
          if (isLocalPreview && ['http:', 'https:'].includes(endpoint.protocol)) return endpoint.href;
        } catch (_) {}
        return null;
      }

      track(event, extra = {}) {
        if (this.dataset.designMode === 'true') return false;
        try {
          const privacy = window.Shopify?.customerPrivacy;
          if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return false;
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event,
            campaign_id: this.dataset.campaign.replace(/[^a-z0-9_-]/gi, '').slice(0, 96),
            variant_id: this.dataset.variant.replace(/[^a-z0-9_-]/gi, '').slice(0, 96),
            marketing_allowed: this.marketingAllowed(),
            ...extra
          });
          return true;
        } catch (_) {
          return false;
        }
      }

      bindPageEvents() {
        if (!this.constructor.pageEventsBound) {
          this.constructor.pageEventsBound = true;
          document.addEventListener('click', (event) => {
            const link = event.target.closest('[data-fabtech-event]');
            const activeForm = document.querySelector('cb-fabtech-form');
            if (!link || !activeForm) return;
            const eventName = link.dataset.fabtechEvent;
            if (!['cta_click', 'phone_click', 'registration_click', 'map_click'].includes(eventName)) return;
            const location = (link.dataset.fabtechLocation || 'page').replace(/[^a-z0-9_-]/gi, '').slice(0, 40);
            activeForm.track(`fabtech_${eventName}`, { cta_location: location });
          });
          document.addEventListener('visitorConsentCollected', () => {
            document.querySelector('cb-fabtech-form')?.trackPageView();
          });
        }
        this.trackPageView();
        if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function' && !this.constructor.privacyRequested) {
          this.constructor.privacyRequested = true;
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
            if (!error) document.querySelector('cb-fabtech-form')?.trackPageView();
          });
        }
      }

      trackPageView() {
        if (!this.constructor.pageViewTracked && this.track('fabtech_page_view')) {
          this.constructor.pageViewTracked = true;
        }
      }

      marketingAllowed() {
        try {
          return window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
        } catch (_) {
          return false;
        }
      }

      showStatus(message, state) {
        this.dataset.state = state;
        this.status.textContent = message;
        this.status.hidden = false;
        this.status.focus({ preventScroll: true });
      }

      payload() {
        const payload = new FormData(this.form);
        for (const name of ['full_name', 'email', 'company', 'phone', 'notes']) {
          payload.set(name, String(payload.get(name) || '').trim());
        }
        payload.set('marketing_consent', this.form.elements.marketing_consent.checked ? 'true' : 'false');
        payload.set('consent_version', 'fabtech-2026-v1');
        payload.set('submission_id', this.submissionId);
        payload.set('campaign_id', this.dataset.campaign);
        payload.set('variant_id', this.dataset.variant);
        payload.set('source', 'fabtech_landing');
        payload.set('page_path', window.location.pathname);
        payload.set('landing_url', window.location.origin + window.location.pathname);
        payload.set('form_elapsed_ms', String(Date.now() - this.startedAt));
        payload.set('submitted_at', new Date().toISOString());
        const marketingAllowed = this.marketingAllowed();
        payload.set('tracking_marketing_allowed', String(marketingAllowed));
        if (marketingAllowed) {
          let referrer = '';
          try {
            const parsedReferrer = new URL(document.referrer);
            if (['http:', 'https:'].includes(parsedReferrer.protocol)) referrer = parsedReferrer.origin;
          } catch (_) {}
          payload.set('referrer', referrer);
          const params = new URLSearchParams(window.location.search);
          const allowlist = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid'];
          for (const name of allowlist) {
            const value = params.get(name);
            if (value) payload.set(name, value.replace(/[\u0000-\u001f\u007f]/g, '').slice(0, 256));
          }
        }
        return payload;
      }

      async submit(event) {
        event.preventDefault();
        if (!this.endpoint || this.dataset.designMode === 'true' || this.pending || this.completed) return;
        for (const name of ['full_name', 'company']) {
          const input = this.form.elements[name];
          input.value = input.value.trim();
        }
        if (!this.form.reportValidity()) return;
        if (this.form.elements.website.value.trim()) {
          this.showStatus(this.messages.error, 'error');
          return;
        }
        const payload = this.payload();
        this.pending = true;
        this.fields.disabled = true;
        this.button.disabled = true;
        this.label.textContent = this.messages.sending;
        this.form.setAttribute('aria-busy', 'true');
        this.dataset.state = 'submitting';
        this.status.hidden = true;
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 20000);
        try {
          const response = await fetch(this.endpoint, {
            method: 'POST',
            body: payload,
            mode: 'cors',
            credentials: 'omit',
            redirect: 'error',
            signal: controller.signal
          });
          const result = await response.json();
          if (!response.ok || result?.ok !== true || typeof result.lead_id !== 'string' || !result.lead_id.trim()) {
            throw new Error('unconfirmed_response');
          }
          this.completed = true;
          this.fields.hidden = true;
          this.showStatus(this.messages.success, 'success');
          this.track('fabtech_lead_success');
        } catch (error) {
          const timedOut = error.name === 'AbortError';
          this.showStatus(timedOut ? this.messages.timeout : this.messages.error, 'error');
          this.track('fabtech_form_error', { error_type: timedOut ? 'timeout' : 'unconfirmed_response' });
        } finally {
          window.clearTimeout(timeout);
          this.pending = false;
          this.form.removeAttribute('aria-busy');
          this.fields.disabled = this.completed === true;
          this.button.disabled = this.completed === true;
          this.label.textContent = this.submitLabel;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-bottom-nav"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mobile-bottom-nav')) {
    customElements.define(
      'mobile-bottom-nav',
      class MobileBottomNav extends HTMLElement {
        connectedCallback() {
          this.links = Array.from(this.querySelectorAll('.mobile-bottom-nav__link'));
          this.cartLink = this.querySelector('[data-mobile-bottom-cart]');
          this.cartBadge = this.querySelector('[data-mobile-bottom-cart-badge]');
          this.cartCount = this.querySelector('[data-mobile-bottom-cart-count]');
          this.cartLabel = this.cartLink?.dataset.cartLabel || 'Cart';
          this.onCartUpdate = this.onCartUpdate.bind(this);
          this.onCartClick = this.onCartClick.bind(this);
          this.onCartKeydown = this.onCartKeydown.bind(this);
          this.onPageShow = this.onPageShow.bind(this);
          this.setupCartSubscription = this.setupCartSubscription.bind(this);

          this.links.forEach((link) => {
            link.addEventListener('pointerdown', () => this.showPressFeedback(link));
            link.addEventListener('keydown', (event) => {
              if (event.key === 'Enter' || event.key === ' ') this.showPressFeedback(link);
            });
          });

          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.setupCartSubscription, { once: true });
          } else {
            this.setupCartSubscription();
          }

          document.addEventListener('cb:cart-updated', this.onCartUpdate);
          window.addEventListener('pageshow', this.onPageShow);
          this.cartLink?.addEventListener('click', this.onCartClick);
          this.cartLink?.addEventListener('keydown', this.onCartKeydown);
        }

        disconnectedCallback() {
          this.unsubscribe?.();
          document.removeEventListener('DOMContentLoaded', this.setupCartSubscription);
          document.removeEventListener('cb:cart-updated', this.onCartUpdate);
          window.removeEventListener('pageshow', this.onPageShow);
          this.cartLink?.removeEventListener('click', this.onCartClick);
          this.cartLink?.removeEventListener('keydown', this.onCartKeydown);
          this.cartController?.abort();
        }

        showPressFeedback(link) {
          link.classList.remove('is-pressed');
          requestAnimationFrame(() => link.classList.add('is-pressed'));
          window.setTimeout(() => link.classList.remove('is-pressed'), 380);
        }

        setupCartSubscription() {
          if (this.unsubscribe) return;
          if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate);
        }

        onCartClick(event) {
          const cartDrawer = document.querySelector('cart-drawer');
          if (!cartDrawer || typeof cartDrawer.open !== 'function') return;

          event.preventDefault();
          cartDrawer.open(this.cartLink);
        }

        onCartKeydown(event) {
          if (event.key !== ' ') return;
          this.onCartClick(event);
        }

        onCartUpdate(event) {
          const itemCount = event?.cartData?.item_count;

          if (Number.isInteger(itemCount)) {
            this.updateCartCount(itemCount);
            return;
          }

          this.refreshCartCount();
        }

        onPageShow(event) {
          if (event.persisted) this.refreshCartCount();
        }

        async refreshCartCount() {
          this.cartController?.abort();
          this.cartController = new AbortController();

          try {
            const response = await fetch(`${window.routes.cart_url}.js`, {
              signal: this.cartController.signal,
              headers: { Accept: 'application/json' },
            });

            if (!response.ok) return;
            const cart = await response.json();
            this.updateCartCount(cart.item_count || 0);
          } catch (error) {
            if (error.name !== 'AbortError') console.error(error);
          }
        }

        updateCartCount(count) {
          if (!this.cartLink || !this.cartBadge || !this.cartCount) return;

          this.cartCount.textContent = count > 99 ? '99+' : String(count);
          this.cartBadge.hidden = count === 0;
          this.cartLink.setAttribute('aria-label', count > 0 ? `${this.cartLabel} (${count})` : this.cartLabel);

          if (count > 0) {
            this.cartBadge.classList.remove('is-updating');
            requestAnimationFrame(() => this.cartBadge.classList.add('is-updating'));
            window.setTimeout(() => this.cartBadge.classList.remove('is-updating'), 450);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["page-navigation-feedback"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('page-navigation-feedback')) {
    customElements.define(
      'page-navigation-feedback',
      class PageNavigationFeedback extends HTMLElement {
        connectedCallback() {
          this.onDocumentClick = this.onDocumentClick.bind(this);
          this.onDocumentSubmit = this.onDocumentSubmit.bind(this);
          this.onPageShow = this.onPageShow.bind(this);
          this.onPageSwap = this.onPageSwap.bind(this);
          this.onPageReveal = this.onPageReveal.bind(this);

          document.addEventListener('click', this.onDocumentClick);
          document.addEventListener('submit', this.onDocumentSubmit);
          window.addEventListener('pageshow', this.onPageShow);
          window.addEventListener('pageswap', this.onPageSwap);
          window.addEventListener('pagereveal', this.onPageReveal);
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onDocumentClick);
          document.removeEventListener('submit', this.onDocumentSubmit);
          window.removeEventListener('pageshow', this.onPageShow);
          window.removeEventListener('pageswap', this.onPageSwap);
          window.removeEventListener('pagereveal', this.onPageReveal);
        }

        onDocumentClick(event) {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

          const link = event.target.closest('a[href]');
          if (!link || link.hasAttribute('download') || link.dataset.noPageTransition !== undefined) return;
          if (link.target && link.target !== '_self') return;

          const href = link.getAttribute('href');
          if (!href || href.startsWith('#')) return;

          const destination = new URL(link.href, window.location.href);
          if (!['http:', 'https:'].includes(destination.protocol) || destination.origin !== window.location.origin) return;
          if (destination.pathname === window.location.pathname && destination.search === window.location.search && destination.hash) return;

          this.startFeedback();
        }

        onDocumentSubmit(event) {
          if (event.defaultPrevented || event.target.dataset.noPageTransition !== undefined) return;
          if (event.target.target && event.target.target !== '_self') return;
          if (event.target.method?.toLowerCase() === 'dialog') return;

          const destination = new URL(event.target.action || window.location.href, window.location.href);
          if (destination.origin !== window.location.origin) return;

          this.startFeedback();
        }

        onPageShow() {
          document.documentElement.classList.remove('cb-page-is-navigating');
        }

        onPageSwap(event) {
          if (!event.viewTransition || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          event.viewTransition.skipTransition();
        }

        onPageReveal(event) {
          if (!event.viewTransition) return;

          const cancelTransition = () => event.viewTransition.skipTransition();
          const cleanup = () => window.removeEventListener('pointerdown', cancelTransition);

          window.addEventListener('pointerdown', cancelTransition, { once: true });
          event.viewTransition.finished.finally(cleanup);
        }

        startFeedback() {
          document.documentElement.classList.add('cb-page-is-navigating');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
